import PubSub from "underpub-js";

var ModalCenter = function(options) {

	this.options = {
		$el: false,
		baseClass: 'mol-ModalCenter',
	};

	$.extend(true, this.options, options);

};

ModalCenter.prototype.init = function() {

	var self = this;

};

export default ModalCenter;
